import React, { ReactElement } from 'react';
import { Box, Pagination, Typography, Skeleton } from '@mui/material';

interface AdminPaginationProps {
  currentPage: number;
  totalPages: number;
  totalCount: number;
  pageSize: number;
  loading?: boolean;
  onChange: (page: number) => void;
}

export function AdminPagination({
  currentPage,
  totalPages,
  totalCount,
  pageSize,
  loading = false,
  onChange
}: AdminPaginationProps): ReactElement {
  if (loading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        mb: 2,
        flexWrap: 'wrap',
        gap: 2
      }}>
        <Skeleton variant="text" width={200} height={20} />
        <Skeleton variant="rectangular" width={300} height={40} />
      </Box>
    );
  }

  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center',
      mb: 2,
      flexWrap: 'wrap',
      gap: 2
    }}>
      <Typography variant="body2" color="text.secondary">
        Showing {Math.min((currentPage - 1) * pageSize + 1, totalCount)} to {Math.min(currentPage * pageSize, totalCount)} of {totalCount} entries
        {totalPages > 1 && ` (Page ${currentPage} of ${totalPages})`}
      </Typography>
      
      {totalPages > 1 && (
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          mt: 3,
          p: 2,
          bgcolor: 'background.paper',
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider'
        }}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(event, page) => onChange(page)}
            color="primary"
            size="large"
            showFirstButton
            showLastButton
            sx={{
              '& .MuiPaginationItem-root': {
                color: 'text.primary',
                '&.Mui-selected': {
                  bgcolor: 'primary.main',
                  color: 'white',
                  '&:hover': {
                    bgcolor: 'primary.dark'
                  }
                },
                '&:hover': {
                  bgcolor: 'action.hover'
                }
              }
            }}
          />
        </Box>
      )}
    </Box>
  );
}


